
import { Vue, Component, Prop } from "vue-property-decorator";

@Component({
  components: {}
})
export default class PanelHeaderButton extends Vue {
  @Prop({ default: true })
  enabled!: boolean;
}
